import _jpLcAqFkW2hd3lODXyl7 from '../unmerged_dictionary/access-key-creation-form-schema.json' with { type: 'json' };
import _TlVw8KB2sDGXJTh2tbkp from '../unmerged_dictionary/access-key-creation-form.json' with { type: 'json' };
import _Vj8JJe9vw59OQHD2Mwnw from '../unmerged_dictionary/access-key-form.json' with { type: 'json' };
import _Z3tMYh4xxyJ4vYCihhgV from '../unmerged_dictionary/ai-ab-testing-section.json' with { type: 'json' };
import _ViOshwx7l3PoCVA2Ea75 from '../unmerged_dictionary/application-not-running-view.json' with { type: 'json' };
import _dif13NYQ54fRfMcGbuhM from '../unmerged_dictionary/application-template-message.json' with { type: 'json' };
import _WQknyKNvflJjVdQiQvEt from '../unmerged_dictionary/aside-navigation.json' with { type: 'json' };
import _JCXips099ryrq7m0BC9R from '../unmerged_dictionary/ask-reset-password-schema.json' with { type: 'json' };
import _s0OykXkWU2SXUq95sLc8 from '../unmerged_dictionary/ask-reset-password.json' with { type: 'json' };
import _xtYOxp49yOI5EtF4PTFT from '../unmerged_dictionary/autocompletion-section.json' with { type: 'json' };
import _IvdXbrBbrQzkdjEFBE92 from '../unmerged_dictionary/available-techno-section.json' with { type: 'json' };
import _PBrVDheYih5VHmg3aqZw from '../unmerged_dictionary/blog-data.json' with { type: 'json' };
import _LUIbTWadgVyfubBRPQ5a from '../unmerged_dictionary/blog-metadata.json' with { type: 'json' };
import _pynQkJmREOIS2hgaAzc7 from '../unmerged_dictionary/blog-nav-list.json' with { type: 'json' };
import _IwjZ1G7ooPUAz3maT7la from '../unmerged_dictionary/blog-page.json' with { type: 'json' };
import _SaJew27fKYBjullf6cyZ from '../unmerged_dictionary/blog-search-metadata.json' with { type: 'json' };
import _m8k6RWHqGURafcvi509z from '../unmerged_dictionary/blog-search-page.json' with { type: 'json' };
import _GsfJpYGKbU8fBU5eOKjp from '../unmerged_dictionary/breadcrumb.json' with { type: 'json' };
import _NA8AC2tRRywH6xftoSIB from '../unmerged_dictionary/change-password-form-schema.json' with { type: 'json' };
import _P5ChEM6FZ6z36brKI491 from '../unmerged_dictionary/change-password-form.json' with { type: 'json' };
import _1zcwJQpsauND4hmGO8lS from '../unmerged_dictionary/change-password-metadata.json' with { type: 'json' };
import _WXNjr4qUIWjb9Vvb4klO from '../unmerged_dictionary/change-password-page.json' with { type: 'json' };
import _8c7loI2PXXfWV3ncJwi3 from '../unmerged_dictionary/change-password-schema.json' with { type: 'json' };
import _nLBSQZqMAIKNJ9GqBFPj from '../unmerged_dictionary/chat-form-related-files.json' with { type: 'json' };
import _TilYPkbL97HcBZ3fq43c from '../unmerged_dictionary/chat-form-section-schema.json' with { type: 'json' };
import _ZeGtyM7gB3Y4O5RXXhjy from '../unmerged_dictionary/chat-form-section.json' with { type: 'json' };
import _mJ9ADLuvMje3GSBu8zhF from '../unmerged_dictionary/chat.json' with { type: 'json' };
import _k10EjDUomq22tqTFu4nx from '../unmerged_dictionary/chatbot-modal.json' with { type: 'json' };
import _ppyqGljkxl7LUikfhqba from '../unmerged_dictionary/checking-application-status-view.json' with { type: 'json' };
import _7VJdjnJuNxyCdNbjwVUX from '../unmerged_dictionary/code.json' with { type: 'json' };
import _2IkX3121oX7O1gH7txG5 from '../unmerged_dictionary/common-questions.json' with { type: 'json' };
import _8wMBI1HA4fFWLUk9YFcE from '../unmerged_dictionary/confirmation-step.json' with { type: 'json' };
import _625x0zY21S0mCkb3lGTL from '../unmerged_dictionary/content-dashboard-metadata.json' with { type: 'json' };
import _C7BChRH7RKsMO6ZjZqL5 from '../unmerged_dictionary/content-dashboard-page.json' with { type: 'json' };
import _5c7LJfkoWN8iO4epMc6p from '../unmerged_dictionary/contribution-message.json' with { type: 'json' };
import _nOjDaJZWw7On9zP0igwr from '../unmerged_dictionary/copy-button.json' with { type: 'json' };
import _lOmA3ZamhrlK3bZz9Ael from '../unmerged_dictionary/copy-markdown-message.json' with { type: 'json' };
import _N2HFeCXlG1pu9GigTuHu from '../unmerged_dictionary/creative-work-structured-data.json' with { type: 'json' };
import _WwRVN711FMV1BmYigA3K from '../unmerged_dictionary/dashboard-footer.json' with { type: 'json' };
import _3AoDIpEid9OhbLF0ys2a from '../unmerged_dictionary/dashboard-metadata.json' with { type: 'json' };
import _s6e2QhfmIAjyFckNU11a from '../unmerged_dictionary/dashboard-navbar-content.json' with { type: 'json' };
import _iVQtkmeZgO91L39kKni5 from '../unmerged_dictionary/dashboard-navbar.json' with { type: 'json' };
import _b7RENM7T4ulqhiGlV7fQ from '../unmerged_dictionary/dashboard-not-found-metadata.json' with { type: 'json' };
import _1gXiYWPwPCtNcyPtNj0B from '../unmerged_dictionary/dashboard-page.json' with { type: 'json' };
import _hdVfSdX5lY2GMRuarb20 from '../unmerged_dictionary/define-password-form-schema.json' with { type: 'json' };
import _6to7yEde4gWN7HVDSM9I from '../unmerged_dictionary/define-password-form.json' with { type: 'json' };
import _5F8jXyjG1amGqwqOz8Dl from '../unmerged_dictionary/define-password-schema.json' with { type: 'json' };
import _xletS77nLfgRXzptn0yv from '../unmerged_dictionary/define-password-step.json' with { type: 'json' };
import _w6Ess2aV0lSkVSdvuofQ from '../unmerged_dictionary/delete-organization-modal.json' with { type: 'json' };
import _uinDDicRTNUwpkhfU7Sr from '../unmerged_dictionary/delete-project-modal.json' with { type: 'json' };
import _0P5ag5y1HJ2NZKTCMWjf from '../unmerged_dictionary/delete-tag-modal.json' with { type: 'json' };
import _raRKjP0EdzgJMUYlsfnw from '../unmerged_dictionary/demo-metadata.json' with { type: 'json' };
import _JtEA9LmSvP7iI0yn9PVs from '../unmerged_dictionary/demo-page.json' with { type: 'json' };
import _S0Osr6FJguyALNGWpVyn from '../unmerged_dictionary/demo-section.json' with { type: 'json' };
import _AbXjQdwQp4RY9fACthUj from '../unmerged_dictionary/dictionary-dashboard-page.json' with { type: 'json' };
import _mIlW4UVmOfjTGahjolDN from '../unmerged_dictionary/dictionary-detail-schema.json' with { type: 'json' };
import _OXZfFndgVKhaTXp9UQcT from '../unmerged_dictionary/dictionary-details.json' with { type: 'json' };
import _w2YxDAcHTd6hiClGg3rJ from '../unmerged_dictionary/dictionary-edition-drawer.json' with { type: 'json' };
import _FY8c1S6HgR7lXEIJbydJ from '../unmerged_dictionary/dictionary-field-editor.json' with { type: 'json' };
import _zzAqIQwPiStZXluESF9G from '../unmerged_dictionary/dictionary-form-schema.json' with { type: 'json' };
import _HymkMPZxuJwX8izTQndM from '../unmerged_dictionary/dictionary-form.json' with { type: 'json' };
import _HIkR6XIorNHsjbOa7tlj from '../unmerged_dictionary/dictionary-list-drawer.json' with { type: 'json' };
import _zCOPnXkbx8QRobj8E9on from '../unmerged_dictionary/doc-chat-metadata.json' with { type: 'json' };
import _iaq2c8tFCDRuUXjeJCBA from '../unmerged_dictionary/doc-chat-page.json' with { type: 'json' };
import _Fgv2CJkM0oqRv45Cf40X from '../unmerged_dictionary/doc-data.json' with { type: 'json' };
import _LUdeYdhwGTNeRYgJHmby from '../unmerged_dictionary/doc-header.json' with { type: 'json' };
import _F2sNDbhVMoDui8N28wL1 from '../unmerged_dictionary/doc-metadata.json' with { type: 'json' };
import _1gZsm5XpmIr31EbdRo6s from '../unmerged_dictionary/doc-nav-list.json' with { type: 'json' };
import _qfGULhbqPYTiuRTMN8xg from '../unmerged_dictionary/doc-page.json' with { type: 'json' };
import _081dg2zOhupu8QqisXcY from '../unmerged_dictionary/doc-search-metadata.json' with { type: 'json' };
import _Fe3XzwP2fueJWXLuq8rJ from '../unmerged_dictionary/doc-search-page.json' with { type: 'json' };
import _s5Hnvi4oyRn7jxvyJEUg from '../unmerged_dictionary/doc-search-trigger.json' with { type: 'json' };
import _giAT4oS8JzyFguIZVtEi from '../unmerged_dictionary/doc-search-view.json' with { type: 'json' };
import _qhktTsxAjVF0s8AObtze from '../unmerged_dictionary/editor-dashboard-metadata.json' with { type: 'json' };
import _X0mrx8RX3ZPc7a7c76l3 from '../unmerged_dictionary/editor-dashboard-page.json' with { type: 'json' };
import _F7hjBERsEiCCqBA6T03e from '../unmerged_dictionary/email-registration-toast.json' with { type: 'json' };
import _lr769sCTGpou8y08gAn0 from '../unmerged_dictionary/expand-collapse.json' with { type: 'json' };
import _Pbgi2Be2oPTf8LHad4v1 from '../unmerged_dictionary/externals-login-buttons.json' with { type: 'json' };
import _68kOa5AEIa2XN2QY0xsF from '../unmerged_dictionary/features-section.json' with { type: 'json' };
import _AFPhncK1O5NokXYuU4UT from '../unmerged_dictionary/footer.json' with { type: 'json' };
import _2NZlmlOuc8WBSSewJPxH from '../unmerged_dictionary/landing-section-action-button.json' with { type: 'json' };
import _Sp3oW2nVuXYdBLQ0aJlQ from '../unmerged_dictionary/landing-section.json' with { type: 'json' };
import _NYYp6o2J2H6KfWmwWPgo from '../unmerged_dictionary/loader.json' with { type: 'json' };
import _wz2RhOXKnO8N4tTdLQLm from '../unmerged_dictionary/locale-metadata.json' with { type: 'json' };
import _udUd8YkuN7jUepDbb6Xj from '../unmerged_dictionary/locale-switcher-content.json' with { type: 'json' };
import _YwikuixvmZDDjJ4XNlIq from '../unmerged_dictionary/locale-switcher.json' with { type: 'json' };
import _pn8l8MSKKN4nmByioT1t from '../unmerged_dictionary/login-metadata.json' with { type: 'json' };
import _RxMMJ3pTCF7cpM0YdiOI from '../unmerged_dictionary/long-press-message.json' with { type: 'json' };
import _jiuRk3xvKGb1AsiIVdz1 from '../unmerged_dictionary/markdown-section.json' with { type: 'json' };
import _QWgRrfNAVVVrQSbQcx2f from '../unmerged_dictionary/mcp-message.json' with { type: 'json' };
import _clRyApxSsxszd4SAoYTz from '../unmerged_dictionary/members-form-schema.json' with { type: 'json' };
import _WiFap1wTx7IzDv2gv5v7 from '../unmerged_dictionary/multilingual-section.json' with { type: 'json' };
import _XJjpf1cGmQahcvRFuBAt from '../unmerged_dictionary/nav-titles.json' with { type: 'json' };
import _3GUtAlcuxrhvXOm9h88a from '../unmerged_dictionary/navbar.json' with { type: 'json' };
import _2eM75HoexgVzYFXOlnwD from '../unmerged_dictionary/navigation-view.json' with { type: 'json' };
import _GI9bS6TGDy6rHgKHUcMi from '../unmerged_dictionary/new-members-form-schema.json' with { type: 'json' };
import _RYpgBjZJWwAV3p1cYMP7 from '../unmerged_dictionary/no-application-url-view.json' with { type: 'json' };
import _sA17tXS6DkWc4jBrHFIL from '../unmerged_dictionary/node-type-selector.json' with { type: 'json' };
import _lTEX6XGPGUQZTLlF050e from '../unmerged_dictionary/not-found-metadata.json' with { type: 'json' };
import _Jb3YfwcpoEae4BPDW33u from '../unmerged_dictionary/not-found.json' with { type: 'json' };
import _qsMiRUGRv7Aldy2ZHixS from '../unmerged_dictionary/onboard-page.json' with { type: 'json' };
import _LeRn3unA8lz6iSLt5BP0 from '../unmerged_dictionary/onboarding-metadata.json' with { type: 'json' };
import _HUbdV5ZtF1I5oPsOOiyR from '../unmerged_dictionary/organization-dashboard-metadata.json' with { type: 'json' };
import _21GOzFGOVePVQjqyfTse from '../unmerged_dictionary/organization-dashboard-page.json' with { type: 'json' };
import _XvpzuP9ig2rjHpHku53z from '../unmerged_dictionary/organization-form-schema.json' with { type: 'json' };
import _SgjCOMt6AaA3QrHnA6yP from '../unmerged_dictionary/organization-form.json' with { type: 'json' };
import _VOquTo1XBwbRwpOfxIuP from '../unmerged_dictionary/organization-members-form.json' with { type: 'json' };
import _314pITpF4sHK474ncs3U from '../unmerged_dictionary/organization-plan.json' with { type: 'json' };
import _EAv7JUdJt3XoLVDkbffE from '../unmerged_dictionary/payment-step.json' with { type: 'json' };
import _xik5cxtn52w9I1k24D0b from '../unmerged_dictionary/playground-metadata.json' with { type: 'json' };
import _SJCodHOWhcs2r0yYgUHE from '../unmerged_dictionary/playground-page.json' with { type: 'json' };
import _8uho1u0AdLsKGlyBcx45 from '../unmerged_dictionary/pricing-metadata.json' with { type: 'json' };
import _zi8VQJFbRlO7BX9CboSg from '../unmerged_dictionary/pricing.json' with { type: 'json' };
import _egbDkgrn4XAoQmjDFSLS from '../unmerged_dictionary/product-header-structured-data.json' with { type: 'json' };
import _AqN5GCv1GB6FC6m9S3rI from '../unmerged_dictionary/product-hunt.json' with { type: 'json' };
import _7Y5cgH6RsIb9QirsImlI from '../unmerged_dictionary/profile-dashboard-metadata.json' with { type: 'json' };
import _OdngpnOVKkHuLAHrp4Dt from '../unmerged_dictionary/profile-dashboard-page.json' with { type: 'json' };
import _dWGEwD75QKl12RDFeVVu from '../unmerged_dictionary/profile-form-schema.json' with { type: 'json' };
import _e7mdWNVc2Ee4habQK8l4 from '../unmerged_dictionary/profile-form.json' with { type: 'json' };
import _gSDDKqRUmvsKd25SYC78 from '../unmerged_dictionary/project-config-detail.json' with { type: 'json' };
import _SLIwUnbsu9s6DcWhAq19 from '../unmerged_dictionary/project-dashboard-metadata.json' with { type: 'json' };
import _k8cEnSZEkYk34TFlFeZv from '../unmerged_dictionary/project-form-schema.json' with { type: 'json' };
import _LjD0eIu2aIOYcJGo7gzy from '../unmerged_dictionary/project-form.json' with { type: 'json' };
import _uob8zRLUs4rgCMfXM6wC from '../unmerged_dictionary/project-list.json' with { type: 'json' };
import _7caZ7RG4rX1zxovqMviX from '../unmerged_dictionary/project-members-form.json' with { type: 'json' };
import _60v615OiIGHQtYNynZbK from '../unmerged_dictionary/projects-dashboard-page.json' with { type: 'json' };
import _zF7KnVNOe3x9rrfzDCyb from '../unmerged_dictionary/register-metadata.json' with { type: 'json' };
import _ap8WqYO3xwtO7GiT7pq1 from '../unmerged_dictionary/register-password-schema.json' with { type: 'json' };
import _wIRlLOinKRgszBCsQ0sC from '../unmerged_dictionary/register-step.json' with { type: 'json' };
import _6Kq6jqSpHGafbmCDTxqU from '../unmerged_dictionary/remove-member-modal.json' with { type: 'json' };
import _ZzqJ6LI2GxN4tiWxahYC from '../unmerged_dictionary/reset-password-metadata.json' with { type: 'json' };
import _YuYEvFQDKvUNruq0Wfqc from '../unmerged_dictionary/reset-password-page.json' with { type: 'json' };
import _bsq7IhztOqA7nGhWsE8p from '../unmerged_dictionary/save-dictionary-details.json' with { type: 'json' };
import _lINOYnhwy9HBfjRGCRF4 from '../unmerged_dictionary/set-up-organization-schema.json' with { type: 'json' };
import _G3w8RT5zPpYVKNYWGgL3 from '../unmerged_dictionary/set-up-organization-step.json' with { type: 'json' };
import _67aXuY3GJlNDZH9anJg5 from '../unmerged_dictionary/sign-in-page.json' with { type: 'json' };
import _l6VPfi3AGpDA3Wmm0gvY from '../unmerged_dictionary/sign-in-schema.json' with { type: 'json' };
import _8TagfpNBvJaHohx67rhK from '../unmerged_dictionary/sign-in.json' with { type: 'json' };
import _J4xkht8QQrbEkK8FGOSH from '../unmerged_dictionary/sign-up-form.json' with { type: 'json' };
import _hl0zachBM0WydmiJKMkB from '../unmerged_dictionary/sign-up-page.json' with { type: 'json' };
import _2tP4GkmywOHfJyPTpsCA from '../unmerged_dictionary/sign-up-schema.json' with { type: 'json' };
import _mMD8CmIuGolRCZjyhErW from '../unmerged_dictionary/software-application-structured-data.json' with { type: 'json' };
import _lFLPxYUqyTIWCLcKDfdZ from '../unmerged_dictionary/step-layout.json' with { type: 'json' };
import _CC6pXidollupF0XEBdHL from '../unmerged_dictionary/structure-view.json' with { type: 'json' };
import _xTnfbIMgH0keVedBTFIw from '../unmerged_dictionary/summarize-ai.json' with { type: 'json' };
import _2rtqYGQbsbavoZaBJsAZ from '../unmerged_dictionary/table.json' with { type: 'json' };
import _7X42nyeoV4yzXfaeb7PG from '../unmerged_dictionary/tag-dashboard-page.json' with { type: 'json' };
import _eju8EUZ2fRMQptwlJjox from '../unmerged_dictionary/tag-details.json' with { type: 'json' };
import _C4sv48snVi579kWgoWUe from '../unmerged_dictionary/tag-form-schema.json' with { type: 'json' };
import _IvQNzad5fxT7cEh1yyug from '../unmerged_dictionary/tag-form.json' with { type: 'json' };
import _eAtlbYnBJRjbCvCV8Iep from '../unmerged_dictionary/tag-list.json' with { type: 'json' };
import _G4iBST0zvF2N94NzzqxF from '../unmerged_dictionary/tags-dashboard-metadata.json' with { type: 'json' };
import _aVe8eJM5Gph1AO05pGVJ from '../unmerged_dictionary/tags-dashboard-page.json' with { type: 'json' };
import _y8bu68Kcd6zV85fNqaOQ from '../unmerged_dictionary/tags-dictionaries-list.json' with { type: 'json' };
import _2kktVCnt3OR3bvK1aHPr from '../unmerged_dictionary/test.json' with { type: 'json' };
import _uNVAHi1VaAcTbHP9pNpG from '../unmerged_dictionary/translated-content-message.json' with { type: 'json' };
import _AfZM6w8ZeXYnXlY3ZXY6 from '../unmerged_dictionary/verify-email-form.json' with { type: 'json' };
import _D1b3yZA9Dh9Su2yOdqRv from '../unmerged_dictionary/verify-email-step.json' with { type: 'json' };
import _jS9XbzbgoIomSpVF4yqC from '../unmerged_dictionary/version-switcher.json' with { type: 'json' };
import _L4ujpXPVCZjEySrmPKyc from '../unmerged_dictionary/visual-editor-section.json' with { type: 'json' };
import _0oP78sgGbelXXB6mGPIW from '../unmerged_dictionary/website-structured-data.json' with { type: 'json' };
import _Qj5QjJPVZB18D5YekiFy from '../unmerged_dictionary/why-to-chose-intlayer-section.json' with { type: 'json' };
import _aUVUz2dYYf1QrAiP0EiP from '../unmerged_dictionary/youtube-video-message.json' with { type: 'json' };

export default {
  "access-key-creation-form-schema": _jpLcAqFkW2hd3lODXyl7,
  "access-key-creation-form": _TlVw8KB2sDGXJTh2tbkp,
  "access-key-form": _Vj8JJe9vw59OQHD2Mwnw,
  "ai-ab-testing-section": _Z3tMYh4xxyJ4vYCihhgV,
  "application-not-running-view": _ViOshwx7l3PoCVA2Ea75,
  "application-template-message": _dif13NYQ54fRfMcGbuhM,
  "aside-navigation": _WQknyKNvflJjVdQiQvEt,
  "ask-reset-password-schema": _JCXips099ryrq7m0BC9R,
  "ask-reset-password": _s0OykXkWU2SXUq95sLc8,
  "autocompletion-section": _xtYOxp49yOI5EtF4PTFT,
  "available-techno-section": _IvdXbrBbrQzkdjEFBE92,
  "blog-data": _PBrVDheYih5VHmg3aqZw,
  "blog-metadata": _LUIbTWadgVyfubBRPQ5a,
  "blog-nav-list": _pynQkJmREOIS2hgaAzc7,
  "blog-page": _IwjZ1G7ooPUAz3maT7la,
  "blog-search-metadata": _SaJew27fKYBjullf6cyZ,
  "blog-search-page": _m8k6RWHqGURafcvi509z,
  "breadcrumb": _GsfJpYGKbU8fBU5eOKjp,
  "change-password-form-schema": _NA8AC2tRRywH6xftoSIB,
  "change-password-form": _P5ChEM6FZ6z36brKI491,
  "change-password-metadata": _1zcwJQpsauND4hmGO8lS,
  "change-password-page": _WXNjr4qUIWjb9Vvb4klO,
  "change-password-schema": _8c7loI2PXXfWV3ncJwi3,
  "chat-form-related-files": _nLBSQZqMAIKNJ9GqBFPj,
  "chat-form-section-schema": _TilYPkbL97HcBZ3fq43c,
  "chat-form-section": _ZeGtyM7gB3Y4O5RXXhjy,
  "chat": _mJ9ADLuvMje3GSBu8zhF,
  "chatbot-modal": _k10EjDUomq22tqTFu4nx,
  "checking-application-status-view": _ppyqGljkxl7LUikfhqba,
  "code": _7VJdjnJuNxyCdNbjwVUX,
  "common-questions": _2IkX3121oX7O1gH7txG5,
  "confirmation-step": _8wMBI1HA4fFWLUk9YFcE,
  "content-dashboard-metadata": _625x0zY21S0mCkb3lGTL,
  "content-dashboard-page": _C7BChRH7RKsMO6ZjZqL5,
  "contribution-message": _5c7LJfkoWN8iO4epMc6p,
  "copy-button": _nOjDaJZWw7On9zP0igwr,
  "copy-markdown-message": _lOmA3ZamhrlK3bZz9Ael,
  "creative-work-structured-data": _N2HFeCXlG1pu9GigTuHu,
  "dashboard-footer": _WwRVN711FMV1BmYigA3K,
  "dashboard-metadata": _3AoDIpEid9OhbLF0ys2a,
  "dashboard-navbar-content": _s6e2QhfmIAjyFckNU11a,
  "dashboard-navbar": _iVQtkmeZgO91L39kKni5,
  "dashboard-not-found-metadata": _b7RENM7T4ulqhiGlV7fQ,
  "dashboard-page": _1gXiYWPwPCtNcyPtNj0B,
  "define-password-form-schema": _hdVfSdX5lY2GMRuarb20,
  "define-password-form": _6to7yEde4gWN7HVDSM9I,
  "define-password-schema": _5F8jXyjG1amGqwqOz8Dl,
  "define-password-step": _xletS77nLfgRXzptn0yv,
  "delete-organization-modal": _w6Ess2aV0lSkVSdvuofQ,
  "delete-project-modal": _uinDDicRTNUwpkhfU7Sr,
  "delete-tag-modal": _0P5ag5y1HJ2NZKTCMWjf,
  "demo-metadata": _raRKjP0EdzgJMUYlsfnw,
  "demo-page": _JtEA9LmSvP7iI0yn9PVs,
  "demo-section": _S0Osr6FJguyALNGWpVyn,
  "dictionary-dashboard-page": _AbXjQdwQp4RY9fACthUj,
  "dictionary-detail-schema": _mIlW4UVmOfjTGahjolDN,
  "dictionary-details": _OXZfFndgVKhaTXp9UQcT,
  "dictionary-edition-drawer": _w2YxDAcHTd6hiClGg3rJ,
  "dictionary-field-editor": _FY8c1S6HgR7lXEIJbydJ,
  "dictionary-form-schema": _zzAqIQwPiStZXluESF9G,
  "dictionary-form": _HymkMPZxuJwX8izTQndM,
  "dictionary-list-drawer": _HIkR6XIorNHsjbOa7tlj,
  "doc-chat-metadata": _zCOPnXkbx8QRobj8E9on,
  "doc-chat-page": _iaq2c8tFCDRuUXjeJCBA,
  "doc-data": _Fgv2CJkM0oqRv45Cf40X,
  "doc-header": _LUdeYdhwGTNeRYgJHmby,
  "doc-metadata": _F2sNDbhVMoDui8N28wL1,
  "doc-nav-list": _1gZsm5XpmIr31EbdRo6s,
  "doc-page": _qfGULhbqPYTiuRTMN8xg,
  "doc-search-metadata": _081dg2zOhupu8QqisXcY,
  "doc-search-page": _Fe3XzwP2fueJWXLuq8rJ,
  "doc-search-trigger": _s5Hnvi4oyRn7jxvyJEUg,
  "doc-search-view": _giAT4oS8JzyFguIZVtEi,
  "editor-dashboard-metadata": _qhktTsxAjVF0s8AObtze,
  "editor-dashboard-page": _X0mrx8RX3ZPc7a7c76l3,
  "email-registration-toast": _F7hjBERsEiCCqBA6T03e,
  "expand-collapse": _lr769sCTGpou8y08gAn0,
  "externals-login-buttons": _Pbgi2Be2oPTf8LHad4v1,
  "features-section": _68kOa5AEIa2XN2QY0xsF,
  "footer": _AFPhncK1O5NokXYuU4UT,
  "landing-section-action-button": _2NZlmlOuc8WBSSewJPxH,
  "landing-section": _Sp3oW2nVuXYdBLQ0aJlQ,
  "loader": _NYYp6o2J2H6KfWmwWPgo,
  "locale-metadata": _wz2RhOXKnO8N4tTdLQLm,
  "locale-switcher-content": _udUd8YkuN7jUepDbb6Xj,
  "locale-switcher": _YwikuixvmZDDjJ4XNlIq,
  "login-metadata": _pn8l8MSKKN4nmByioT1t,
  "long-press-message": _RxMMJ3pTCF7cpM0YdiOI,
  "markdown-section": _jiuRk3xvKGb1AsiIVdz1,
  "mcp-message": _QWgRrfNAVVVrQSbQcx2f,
  "members-form-schema": _clRyApxSsxszd4SAoYTz,
  "multilingual-section": _WiFap1wTx7IzDv2gv5v7,
  "nav-titles": _XJjpf1cGmQahcvRFuBAt,
  "navbar": _3GUtAlcuxrhvXOm9h88a,
  "navigation-view": _2eM75HoexgVzYFXOlnwD,
  "new-members-form-schema": _GI9bS6TGDy6rHgKHUcMi,
  "no-application-url-view": _RYpgBjZJWwAV3p1cYMP7,
  "node-type-selector": _sA17tXS6DkWc4jBrHFIL,
  "not-found-metadata": _lTEX6XGPGUQZTLlF050e,
  "not-found": _Jb3YfwcpoEae4BPDW33u,
  "onboard-page": _qsMiRUGRv7Aldy2ZHixS,
  "onboarding-metadata": _LeRn3unA8lz6iSLt5BP0,
  "organization-dashboard-metadata": _HUbdV5ZtF1I5oPsOOiyR,
  "organization-dashboard-page": _21GOzFGOVePVQjqyfTse,
  "organization-form-schema": _XvpzuP9ig2rjHpHku53z,
  "organization-form": _SgjCOMt6AaA3QrHnA6yP,
  "organization-members-form": _VOquTo1XBwbRwpOfxIuP,
  "organization-plan": _314pITpF4sHK474ncs3U,
  "payment-step": _EAv7JUdJt3XoLVDkbffE,
  "playground-metadata": _xik5cxtn52w9I1k24D0b,
  "playground-page": _SJCodHOWhcs2r0yYgUHE,
  "pricing-metadata": _8uho1u0AdLsKGlyBcx45,
  "pricing": _zi8VQJFbRlO7BX9CboSg,
  "product-header-structured-data": _egbDkgrn4XAoQmjDFSLS,
  "product-hunt": _AqN5GCv1GB6FC6m9S3rI,
  "profile-dashboard-metadata": _7Y5cgH6RsIb9QirsImlI,
  "profile-dashboard-page": _OdngpnOVKkHuLAHrp4Dt,
  "profile-form-schema": _dWGEwD75QKl12RDFeVVu,
  "profile-form": _e7mdWNVc2Ee4habQK8l4,
  "project-config-detail": _gSDDKqRUmvsKd25SYC78,
  "project-dashboard-metadata": _SLIwUnbsu9s6DcWhAq19,
  "project-form-schema": _k8cEnSZEkYk34TFlFeZv,
  "project-form": _LjD0eIu2aIOYcJGo7gzy,
  "project-list": _uob8zRLUs4rgCMfXM6wC,
  "project-members-form": _7caZ7RG4rX1zxovqMviX,
  "projects-dashboard-page": _60v615OiIGHQtYNynZbK,
  "register-metadata": _zF7KnVNOe3x9rrfzDCyb,
  "register-password-schema": _ap8WqYO3xwtO7GiT7pq1,
  "register-step": _wIRlLOinKRgszBCsQ0sC,
  "remove-member-modal": _6Kq6jqSpHGafbmCDTxqU,
  "reset-password-metadata": _ZzqJ6LI2GxN4tiWxahYC,
  "reset-password-page": _YuYEvFQDKvUNruq0Wfqc,
  "save-dictionary-details": _bsq7IhztOqA7nGhWsE8p,
  "set-up-organization-schema": _lINOYnhwy9HBfjRGCRF4,
  "set-up-organization-step": _G3w8RT5zPpYVKNYWGgL3,
  "sign-in-page": _67aXuY3GJlNDZH9anJg5,
  "sign-in-schema": _l6VPfi3AGpDA3Wmm0gvY,
  "sign-in": _8TagfpNBvJaHohx67rhK,
  "sign-up-form": _J4xkht8QQrbEkK8FGOSH,
  "sign-up-page": _hl0zachBM0WydmiJKMkB,
  "sign-up-schema": _2tP4GkmywOHfJyPTpsCA,
  "software-application-structured-data": _mMD8CmIuGolRCZjyhErW,
  "step-layout": _lFLPxYUqyTIWCLcKDfdZ,
  "structure-view": _CC6pXidollupF0XEBdHL,
  "summarize-ai": _xTnfbIMgH0keVedBTFIw,
  "table": _2rtqYGQbsbavoZaBJsAZ,
  "tag-dashboard-page": _7X42nyeoV4yzXfaeb7PG,
  "tag-details": _eju8EUZ2fRMQptwlJjox,
  "tag-form-schema": _C4sv48snVi579kWgoWUe,
  "tag-form": _IvQNzad5fxT7cEh1yyug,
  "tag-list": _eAtlbYnBJRjbCvCV8Iep,
  "tags-dashboard-metadata": _G4iBST0zvF2N94NzzqxF,
  "tags-dashboard-page": _aVe8eJM5Gph1AO05pGVJ,
  "tags-dictionaries-list": _y8bu68Kcd6zV85fNqaOQ,
  "test": _2kktVCnt3OR3bvK1aHPr,
  "translated-content-message": _uNVAHi1VaAcTbHP9pNpG,
  "verify-email-form": _AfZM6w8ZeXYnXlY3ZXY6,
  "verify-email-step": _D1b3yZA9Dh9Su2yOdqRv,
  "version-switcher": _jS9XbzbgoIomSpVF4yqC,
  "visual-editor-section": _L4ujpXPVCZjEySrmPKyc,
  "website-structured-data": _0oP78sgGbelXXB6mGPIW,
  "why-to-chose-intlayer-section": _Qj5QjJPVZB18D5YekiFy,
  "youtube-video-message": _aUVUz2dYYf1QrAiP0EiP
};
